import api from '../axiosInstance';
import { CUSTOMER_ENDPOINTS } from '../constants';
import { encodeBase64 } from '../../utils/base64Util';


export const listCustomers = (compId) => {
  return api.get(CUSTOMER_ENDPOINTS.LIST(compId));
}

export const getCustomerDetails = async (compId, customerId) => {
  return api.get(CUSTOMER_ENDPOINTS.GET_By_ID(compId, customerId));
}


export const createCustomer = async (compId, customerDetails) => {
  const data = {
    f_name: customerDetails.first_name,
    l_name: customerDetails.last_name,
    comp_name : customerDetails.company_name,
    email: customerDetails.email,
    mobile: customerDetails.mobile,
    cred : encodeBase64(customerDetails.password),
    gst: customerDetails.customer_gst,
    billing_mail: customerDetails.customer_billing,
    customer_address: customerDetails.customer_address,
    comp_id: compId,
  }
  return api.post(CUSTOMER_ENDPOINTS.CREATE, data)
}

export const editCustomer = async (customerDetails) => {
  const data = {
    f_name: customerDetails.first_name,
    l_name: customerDetails.last_name,
    comp_name : customerDetails.company_name,
    mobile: customerDetails.mobile,
    gst: customerDetails.customer_gst,
    billing_mail: customerDetails.customer_billing,
    customer_address: customerDetails.customer_address,
    comp_id: customerDetails.comp_id
  }
  return api.put(CUSTOMER_ENDPOINTS.EDIT(customerDetails.customer_id), data)
}
export const deleteCustomer = async (compId, customerId) => {
  return api.delete(CUSTOMER_ENDPOINTS.DELETE(compId, customerId))
} 

export const showPassCode = async (compId, customerId) => {
	const data = {
		customer_id : customerId
	}
  return api.post(CUSTOMER_ENDPOINTS.PASSCODE(compId), data)
}

export const showAPIKey = async (compId, customerId) => {
  const data = {
		customer_id : customerId
	}
  return api.post(CUSTOMER_ENDPOINTS.GET_API_KEY(compId), data);
}

export const getCustomerSettingsDetails = async (compId, customerId) => {
  return api.get(CUSTOMER_ENDPOINTS.GET_SETTING(compId, customerId));
}

export const updateCustomerSettings = async (compId, customerId, data) => {
  return api.put(CUSTOMER_ENDPOINTS.GET_SETTING(compId, customerId), data);
}

export const getCustomerSubscriptionDetails = async (compId, customerId) => {
  return api.get(CUSTOMER_ENDPOINTS.GET_CUSTOMER_ACCOUNT(compId, customerId));
}

export const getCustomerDevicesList = async (compId, customerId) => {
  return api.get(CUSTOMER_ENDPOINTS.GET_CUSTOMER_DEVICES(compId, customerId));
}

export const createCustomerDevice = async (compId, customerId, details) => {
  const data = {
    mobile: '91'+details.mobile,
    callback_url: details.callback_url, 
  }
  return api.post(CUSTOMER_ENDPOINTS.POST_CUSTOMER_DEVICE(compId, customerId), data);
}

export const updateCustomerDevice = async (compId, customerId, details) => {
  const data = {
    device_id : details.device_id,
    callback_url : details.callback_url,
    mobile : details.mobile,
    device_status : details.device_status
  }
  return api.put(CUSTOMER_ENDPOINTS.PUT_CUSTOMER_DEVICE(compId, customerId), data);
}

export const registerCustomerDevice = async (compId, customerId, deviceId) => {
  const data = {
    device_id : deviceId
  }
  return api.post(CUSTOMER_ENDPOINTS.REG_CUSTOMER_DEVICE(compId, customerId), data);
}

export const deviceQrCodeScan = async (compId, customerId, deviceId) => {
  const data = {
    device_id : deviceId
  }
  return api.post(CUSTOMER_ENDPOINTS.DEVICE_QRCODE(compId, customerId), data);
}

export const deviceLogout = async (compId, customerId, deviceId) => {
  const data = {
    device_id : deviceId,
  }
  return api.post(CUSTOMER_ENDPOINTS.DEVICE_LOGOUT(compId, customerId), data);
}

export const deviceDelete = async (compId, customerId, deviceId) => {
  const data = {
    device_id : deviceId,
  }
  return api.post(CUSTOMER_ENDPOINTS.DEVICE_DELETE(compId, customerId), data);
}


export const updateCustomerSubscription = async (compId, customerId, data) => {
  const details = {
    credit : data.c_credit,
    validity : data.c_validity,
    max_devices : data.c_max_devices,
  }
  return api.post(CUSTOMER_ENDPOINTS.POST_CUSTOMER_ACCOUNT(compId, customerId), details);
}
